import { IComponentController } from 'angular';
import {  IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';


interface IPageAc2008 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}



/* @ngInject */
export default function Ac2008Controller(
    MenuItemEcran: IMenuItemEcranClass,
    ac2009Route: IRoute
)
{
    const vm: IPageAc2008 = this;
    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
        },
        colonnesVisibles: [
            { nom: 'uhcdsc', largeur: 110 , menu: [
                    new MenuItemEcran(
                        'LBL_DSCLNG',
                        ac2009Route.NAME,
                        (rowData: any) => ({
                            id: rowData.uhccleint
                        }),
                        {
                            icon: 'launch',
                            iconButton: true,
                            hidden: (rowData: any) => !rowData.uhcdsclng,
                            fonction: 'BOUUHC',
                            directionTooltip: 'top'
                        }
                    )
                ]
            },
            { nom: 'caadsc', largeur: 110 },
            { nom: 'uhcnumcat', largeur: 110 },
            { nom: 'uhcprxuni', largeur: 110 }
        ],
        colonnesCachees: [
            'uhcdsclng'
        ]

    };
}
